// Import Swiper and modules
import SwiperCore, {Autoplay, Pagination} from 'swiper/core';

// Install modules
const Swiper = SwiperCore.use([Autoplay, Pagination]);

export const _infiniteSwiper = () => {
  //対象の要素
  const slides = document.querySelectorAll('.infinite-swiper');
  //対象の要素が取得できない場合は処理を中断する
  if (slides.length === 0) return;

  //対象の要素が複数ある場合があるのでループで回す
  slides.forEach((slide) => {
    //各要素でSwiperのinstanceを生成する
    const swiper = new Swiper(slide, {
      //速度
      speed: 9000,
      //loop
      loop: true,
      //表示するスライドの枚数
      slidesPerView: 1.5,
      //スライド同士の余白
      spaceBetween: 15,
      breakpoints: {
        600: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
      },
      //表示するスライドをセンターに固定するか
      centeredSlides: true,
      //自動再生の設定
      autoplay: {
        //delayを0にすることで永遠にスライドさせる
        delay: 0,
        //ユーザーのアクション後に自動再生が終わらないように
        disableOnInteraction: false,
      },
      //ページネーションの設定
      pagination: {
        //対象のページネーションのDOM
        el: slide.querySelector('.swiper-pagination'),
        type: 'bullets',
      },
    });

    /**
     * 各ページネーションをクリックしたらそのスライドに移動する
     * speedが上記のオプションのままなので、ここで手動で早くスライドが変わるようにする
     * @type {NodeListOf<HTMLSpanElement>}
     */
      //ページャーのクリックできるDOM
    const paginationElements = swiper.pagination.el.querySelectorAll('span');
    //DOMが複数あるのでループで回す
    paginationElements.forEach((paginationElement, index) => {
      //各ページャーのDOMにクリックイベントを付与する
      paginationElement.addEventListener('click', () => {
        //クリックされたらswiperをindex + 1の番号のスライドに1000msかけてスライドを変える
        swiper.slideTo(index + 2, 1000);
      })
    })
  });
}



// WEBPACK FOOTER //
// ./scripts/modules/_infinite-swiper.js